export default function SkeletonKanban() {
  return (
    <div className="flex gap-4 pb-4">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="flex-shrink-0 w-64">
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-t-xl animate-pulse" />
          <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 border-t-0 rounded-b-xl p-2 space-y-2 min-h-48">
            {[...Array(3)].map((_, j) => <div key={j} className="h-24 bg-gray-200 dark:bg-gray-700 rounded-xl animate-pulse" />)}
          </div>
        </div>
      ))}
    </div>
  );
}
